import React, { useState, useEffect } from "react";
import { Container, Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginAdmin, subscription  } from "../features/admin/adminSlice";
import axios from "axios";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loginError, accessToken } = useSelector((state) => state.admin);
  const [id, setID] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);


  // 로그인 상태 동기화
  const isLoggedIn = user || !!sessionStorage.getItem("token");
  // 로그인 성공 시 리디렉션 처리
  // useEffect(() => {
  //   if (user || sessionStorage.getItem("token")) {
  //     if (location.state?.from) {
  //       window.location.href = location.state.from; 
  //     } else {
  //       window.location.href = "/"; 
  //     }
  //   }
  // }, [user, navigate, location]);

  // 로그인 에러 처리
  useEffect(() => {
    if (loginError) {
      alert(loginError);
    }
  }, [loginError]);

  // 토큰 저장
  useEffect(() => {
    if (accessToken) {
      sessionStorage.setItem("token", accessToken);
    }
  }, [accessToken]);

  // const handleLogin = async (event) => {
  //   event.preventDefault();
  //   setLoading(true);
    
  //   try {
  //     await dispatch(loginAdmin({ id, password })).unwrap();
  //     if (location.state?.from) {
  //       //window.location.href = location.state.from;
  //     } else {
  //       //window.location.href = "/";
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
  
    try {
      await dispatch(loginAdmin({ id, password })).unwrap();
  
      alert("로그인에 성공했습니다.");
  
      if (location.state?.from) {
        navigate(location.state.from, { replace: true });
      } else {
        navigate("/", { replace: true });
      }
  
    } catch (error) {
      // alert("로그인에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      sessionStorage.removeItem("token");
  
      alert("로그아웃 되었습니다.");
      navigate("/", { replace: true });
  
    } catch (error) {
      alert("로그아웃 중 오류가 발생했습니다.");
    }
  };

  const createAdmin = () => {
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/api/admin`, {
        user_id: "admin",
        password: "wiz7737!@",
        name: "관리자",
      })
      .then((response) => {
        // console.log("Admin created:", response.data);
        alert("관리자 계정이 생성되었습니다.");
      })
      .catch((error) => {
        // console.error("Error creating admin:", error);
        alert("관리자 계정 생성에 실패했습니다.");
      });
  };
  
  return (
    <div className="flex-1 d-flex justify-content-center align-items-center">
    <Container className="login-area">
      {isLoggedIn ? (
        <div className="logout-area">
        <h2 className="logout-title">관리자 로그인 상태입니다</h2>
      
        <Button
          variant="danger" 
          onClick={handleLogout}
        >
          로그아웃
        </Button>
      </div>
      ) : (
        <>
          <Form className="login-form" onSubmit={handleLogin}>
           <h2>LOGIN</h2>
            <Form.Group className="mb-3" controlId="formBasicId">
              {/* <Form.Label>ID</Form.Label> */}
              <Form.Control
                type="text"
                placeholder="ID"
                required
                value={id}
                onChange={(e) => setID(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              {/* <Form.Label>Password</Form.Label> */}
              <Form.Control
                type="password"
                placeholder="Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <div className="btn-right">
              <Button variant="danger" type="submit" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" /> 로그인 중...
                  </>
                ) : (
                  "로그인"
                )}
              </Button>
            </div>
            
            <div className="login-msg">
              {loginError && (
              <Alert variant="danger">
                {loginError.message || "알 수 없는 오류가 발생했습니다."}
              </Alert>
            )}
            </div>
          </Form>
          
        </>
      )} 
    </Container>
    </div>
  );
};

export default Login;
